import { api } from 'API'

// The admin area is unlocked by an operator password that only the API knows.
// What the operator typed is kept for the browser session and sent with every
// admin request; the API decides whether it is right.
const ADMIN_PASSWORD_STORAGE_KEY = 'adminPassword'

export async function verifyAdminPassword(password: string): Promise<boolean> {
  const response = await api.post<{ valid: boolean }>('/auth/admin-password/verify', { password })
  return response.data?.valid === true
}

export function saveAdminPassword(password: string): void {
  sessionStorage.setItem(ADMIN_PASSWORD_STORAGE_KEY, password)
}

export function getAdminPasswordHeaders(): Record<string, string> {
  return { 'X-Admin-Password': sessionStorage?.getItem(ADMIN_PASSWORD_STORAGE_KEY) || '' }
}
